import React from 'react';

export function GridLayout({
  children,
  columns = 3,
  gap = '6',
  className = '',
  ...props
}) {
  // Responsive columns: 1 on mobile, 2 on md, N on lg
  const colClass =
    columns === 4
      ? 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
      : columns === 2
      ? 'grid-cols-1 sm:grid-cols-2'
      : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3';
  return (
    <div className={`grid ${colClass} gap-${gap} ${className}`} {...props}>
      {children}
    </div>
  );
}

export default GridLayout;
